import React, { useEffect, useState } from "react";
import "./detailsModalStyles.css";
import { Checkbox, FormControl, FormControlLabel } from "@material-ui/core";
import ErrorPopUp from "../ErrorPopUp";
import Modal from "../Modal";
import i18next from "i18next";
import { useSelector } from "react-redux";
import exit from "../../assets/images/exit.svg";

const DetailsModal = (props) => {
	const [isConfirmedPopUp, setIsConfirmedPopUp] = useState(false);
	const [isActivatedPopUp, setIsActivatedPopUp] = useState(false);
	const [checked, setChecked] = useState(false);
	const [openErrorPopUp, setOpenErrorPopUp] = useState(false);
	const [secondPopUp, setSecondPopUp] = useState(false);
	const [openTerms, setOpenTerms] = useState(false);

	const { isTourist } = useSelector(
		(state) => state.BalanceReducer.payloadAfterLogIn,
	);

	const {
		onHide,
		open,
		bundles,
		passes,
		t,
		activatePackage,
		passesAfterActivation,
		errorActivePackage,
	} = props;

	const handleChangeCheckbox = () => {
		setChecked(!checked);
	};

	const handleConfirmPopUpOpen = () => {
		if (bundles.reason === "") {
			activatePackage(bundles.uid, passes.token);
		} else if (bundles.reason !== "") {
			setOpenErrorPopUp(true);
		}
	};

	useEffect(() => {
		if (errorActivePackage && passesAfterActivation.result !== "SUCCESS") {
			setSecondPopUp(true);
		} else if (passesAfterActivation.result === "SUCCESS") {
			setIsConfirmedPopUp(true);
		}
	}, [errorActivePackage, passesAfterActivation]);

	let temp = null;

	if (isConfirmedPopUp) {
		temp = (
			<div>
				<div
					className={
						open
							? "hover_bkgr_terms_container_prof popup_open"
							: "hover_bkgr_terms_container_prof"
					}
				>
					<div className="simple-popup">
						<div
							className={
								isActivatedPopUp
									? "simple-popup-content simple-popup-content-confirm"
									: "simple-popup-content simple-popup-content-payment"
							}
						>
							<span className="modalTitle">{t("passPopUpTitle")}</span>
							<div className="paymentContent firstElement">
								<div className="removePayments">
									<div className="paymentContentSuccess textc second-element-spacer">
										{t("congratsMessage")}
									</div>
									<div className="paymentContentSuccess second-element-spacer">
										<p>{t("congratsContent")}</p>
										<p>{t("congratsContentParagraph")}</p>
									</div>
								</div>
								<div className="buttonOuter inlineButtons textCenter">
									<a
										href="/"
										className={`button primaryButton primaryButtonNormal${
											checked !== true ? " disabled" : ""
										}`}
									>
										{t("returnHome")}
										<span className="loadingSpinner"></span>
									</a>
								</div>
								<img
									src={exit}
									className="close"
									onClick={onHide}
									alt={t("close")}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	} else {
		temp = (
			<div>
				<div
					className={
						open
							? "hover_bkgr_terms_container_prof popup_open"
							: "hover_bkgr_terms_container_prof"
					}
				>
					<div className="simple-popup">
						<div
							className={
								isActivatedPopUp
									? "simple-popup-content simple-popup-content-confirm"
									: "simple-popup-content simple-popup-content-payment"
							}
						>
							<span className={`modalTitle ${isTourist ? "tourist" : ""}`}>
								{t("confirmMessage")}
							</span>
							<div className="paymentContent firstElement">
								<div className="paymentContentTitle">
									{t("confirmMessageContent")}
								</div>
								<div className="paymentMethod">
									<div className="paymentMethodCol withBorder">
										<FormControl>
											<FormControlLabel
												value={checked}
												onChange={handleChangeCheckbox}
												control={<Checkbox />}
												label={
													<div>
														{t("checkboxTermsAndConditions")}
														<a onClick={() => setOpenTerms(true)}>
															{t("termsAndCond")}
														</a>
														{i18next.language === "ru"
															? t("termsAndCond2")
															: null}
													</div>
												}
											/>
										</FormControl>
									</div>
								</div>
								<div className="buttonOuter textCenter inlineButtons">
									<a
										className={`button primaryButton primaryButtonNormal${
											checked === false ? " disabled" : ""
										}`}
										onClick={handleConfirmPopUpOpen}
									>
										{t("confirm")}
									</a>
								</div>
							</div>
							<img
								src={exit}
								className="close"
								onClick={onHide}
								alt={t("close")}
							/>
						</div>
					</div>
				</div>
			</div>
		);
		{
			/*<div className="toggleBox">*/
		}
		{
			/*    <a className="toggleSimpleContent" onClick={() => setShowDetails(!showDetails)}>{showDetails ? "Δες λιγότερα" : "Δες περισσότερα"}<i className={showDetails ? "symmetry-icon-arrow-up" : "symmetry-icon-arrow-down"}></i></a>*/
		}
		{
			/*    { showDetails ?*/
		}
		{
			/*    <div className="simpleToggledContent">*/
		}
		{
			/*        <p>*/
		}

		{
			/*            - Τα 6GB θα έχουν ισχύ από την Παρασκευή στις 18:00:00 έως και την Κυριακή στις*/
		}
		{
			/*            23:59:00.<br/>*/
		}
		{
			/*            - To πακέτο μπορεί να ενεργοποιηθεί από την Δευτέρα στις 00:00:00 έως και το Σάββατο*/
		}
		{
			/*            στις 23:59:59.<br/>*/
		}
		{
			/*            - Η ενεργοποίηση δεύτερου πακέτου μπορεί να γίνει μόνο εάν έχει καταναλωθεί το*/
		}
		{
			/*            πρώτο.<br/>*/
		}
		{
			/*            - Για τους συνδρομητές που έχουν ενεργοποιημένη την υπηρεσία COSMOTE My Internet, σε*/
		}
		{
			/*            περίπτωση που ο όγκος δεδομένων (MB) καταναλωθεί νωρίτερα από την λήξη του ή*/
		}
		{
			/*            παρέλθει η διάρκειά του και δεν υπάρχουν διαθέσιμα MB από άλλο πακέτο δεδομένων, η*/
		}
		{
			/*            πρόσβαση στο Internet διακόπτεται.&nbsp;<br/>*/
		}
		{
			/*            - Για τους συνδρομητές που δεν έχουν ενεργοποιημένη την υπηρεσία COSMOTE My*/
		}
		{
			/*            Internet, σε περίπτωση που ο όγκος δεδομένων (MB) καταναλωθεί &nbsp;νωρίτερα από την*/
		}
		{
			/*            λήξη του ή παρέλθει η διάρκειά του και δεν υπάρχουν διαθέσιμα MB από άλλο ενεργό*/
		}
		{
			/*            πακέτο δεδομένων, hη χρέωση για την χρήση δεδομένων ανέρχεται σε 0,2€/MB, με μέγιστη*/
		}
		{
			/*            ημερήσια χρέωση τα 2€. Εφόσον οι συνδρομητές φτάσουν την μέγιστη επιτρεπτή ημερήσια*/
		}
		{
			/*            χρήση των 2€, η COSMOTE με σκοπό την απρόσκοπτη παροχή των Υπηρεσιών της, ενδέχεται*/
		}
		{
			/*            να εφαρμόσει πολιτική ορθής χρήσης στο 1,5Mbps, μέχρι τη συμπλήρωση 24 ωρών από την*/
		}
		{
			/*            πρώτη χρήση δεδομένων.<br/>*/
		}
		{
			/*            - Τα ενσωματωμένα ΜΒ του πακέτου είναι διαθέσιμα και στην περιαγωγή εντός ΕΕ/ΕΟΧ.*/
		}
		{
			/*        </p><p></p>*/
		}

		{
			/*        <p>- Στο πακέτο GIGA ΣΚ εφαρμόζεται 1300ΜΒ όριο στη χρήση δεδομένων εντός ΕΕ/ΕΟΧ. Πέραν*/
		}
		{
			/*            του ορίου αυτού και μέχρι την κατανάλωση των διαθέσιμων ΜΒ, θα εφαρμόζεται επιπλέον*/
		}
		{
			/*            χρέωση περιαγωγής 0,0031€/ΜΒ για την οποία ο συνδρομητής θα ενημερώνεται και με*/
		}
		{
			/*            γραπτό μήνυμα.*/
		}

		{
			/*        </p><p></p>*/
		}
		{
			/*    </div> : null}*/
		}
		{
			/*</div>*/
		}
	}

	return (
		<div>
			{temp}
			{/*{(isActivatedPopUp === false && isMessage) ? <PopUpCongrats t={t}*/}
			{/*                                                            open={open}*/}
			{/*                                                            checked={checked}*/}
			{/*                                                            onHide={onHide}*/}
			{/*                                                            isPaymentPopUp={isActivatedPopUp}*/}
			{/*                                                            isOpen={isMessage}*/}
			{/*/> : null}*/}
			{openTerms ? (
				<Modal openTerms={openTerms} setOpenTerms={setOpenTerms} />
			) : null}
			{openErrorPopUp ? (
				<ErrorPopUp
					openErrorPopUp={openErrorPopUp}
					open={open}
					modalData={bundles}
					t={t}
					text={
						bundles.reason === "NOT_ENOUGH_BALANCE"
							? t("notEnoughBalance")
							: t("errorGeneral")
					}
				/>
			) : null}
			{secondPopUp ? (
				<ErrorPopUp
					openErrorPopUp={secondPopUp}
					setOpenErrorPopUp={setSecondPopUp}
					open={open}
					onHide={onHide}
					modalData={bundles}
					t={t}
					text={t("errorGeneral")}
				/>
			) : null}
		</div>
	);
};

export default DetailsModal;
